import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import { removeUserSession } from '../Utils/Common';
import API from '../Utils/Api';


const BusinessHeaderAfterLogin = ({ toggleSidebar }) => {

  const [showInfo, setShowInfo] = useState(false);
  const [businesslist, setBusinesslist] = useState([]);
  const [address, setAddress] = useState("");

  const [neighbourchk, setNeighbourchk] = useState(2);

  const [data, setData] = useState('');

  useEffect(() => {
    API.get('get_user_detail')
      .then(response => {

        if (response.data.status === false) {

        } else {
          setData(response.data.data);
        }
      }).catch(error => {

      });

    API.post('get_all_business')
      .then(response => {
        if (response.data.status === false) {

        } else {
          setBusinesslist(response.data.data);


          const businessId = localStorage.getItem("business_id");
          // find business by id
          const matchedBusiness = response.data.data.find(
            (item) => String(item.business_id) === String(businessId)
          );
          console.log(matchedBusiness);
          if (matchedBusiness) {

            var add = matchedBusiness.business_name + ' - ' + matchedBusiness.town_name
            setAddress(add);
          }

        }
      }).catch(error => {

      });

    API.post('switch_business_to_customer_status')
      .then(response => {

        if (response.data.status === false) {

        } else {
          setNeighbourchk(response.data.data.status);
        }
      }).catch(error => {

      });

  }, []);


  const handleInfo = () => {
    setShowInfo(prev => !prev);
  };
  const setBusiness = (business_id, business_name, town_name) => {
    localStorage.setItem("business_id", business_id);
    var add = business_name + ' - ' + town_name
    setAddress(add);
    window.location.reload();
  }


  const switchneighbor = () => {
    API.post('switch_business_to_customer_status')
      .then(response => {
        if (response.data.status === false) {

        } else {
          if (response.data.data.status === 1) {
            localStorage.setItem("location_id", response.data.data.location_id);
            localStorage.setItem("location_town", response.data.data.location_town_name);

            var loc = '';
            if (response.data.data.location_pincode !== '' && response.data.data.location_town_name !== '') {
              loc = `${response.data.data.location_town_name} - ${response.data.data.location_pincode}`;
            }
            localStorage.setItem("location", loc);
            
            var is_profile_verify3=response.data.data.is_profile_verify;
            localStorage.setItem("is_profile_verify", is_profile_verify3);
            if(is_profile_verify3===1){
              window.location.href = '/neighbour/local-deals';
            }else{
              window.location.href = '/neighbour/edit-profile';
            }
          }

        }
      }).catch(error => {

      });
  }
  /* Start logout */
  const logout = () => {
    removeUserSession();
    window.location.href = "/";
    //<Navigate to="/" />
  }
  /* End logout */

  return (
    <>
      <div className='info-box d-none'>
        <Row className='info-top'>
          <Col><p>Weekend plans need a little extra? extra 15% off should help!</p></Col>
          <Col xs="auto"><Link to="" onClick={handleInfo}> <span> {showInfo ? 'Hide Detail' : 'View Detail'} </span> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/drop-wh.webp'} className={`img-fluid ${showInfo ? 'tr180' : ''}`} alt="drop-wh" /></Link></Col>
        </Row>
        {showInfo && (
          <div className='info-bot'>
            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/info.webp'} className="img-fluid" alt="info" />
            <p>jsdjk sjksjkl jsdkljf sdkljfklsdnkljnsdklfj sdkljklsdjfksjfkljsdlkj</p>
          </div>
        )}
      </div>
      <div className='nei-header org-header'>
        <div>
          <Dropdown className="verify-business mob-hide">
            <Dropdown.Toggle variant="success" id="dropdown-basic" className='header-loc-box '>
              <h6>{address}</h6>
              <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/drop-wh.webp'} className="img-fluid" alt="drop" />
            </Dropdown.Toggle>
            <Dropdown.Menu className='header-loc-drop header-drop'>
              <h6>My Business</h6>
              {businesslist && businesslist.map((val, index) => {
                return (
                  <Link to="#" onClick={() => setBusiness(val.business_id, val.business_name, val.town_name)}>
                    <div>
                      <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/business.webp'} className="img-fluid" alt="business" />
                      <h6>{val.business_name} - {val.town_name}</h6>
                    </div>
                  </Link>
                )
              })}
              <h6>Add Business</h6>
              <Link to="/business/add-new-business" className='ant-box'>
                <div>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/open.webp'} className="img-fluid" alt="open" />
                  <h6>New business</h6>
                </div>
              </Link>
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown>
            <Dropdown.Toggle variant="success" id="dropdown-basic" className='header-user-box'>
              <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/user.webp'} className="img-fluid" alt="user" />
            </Dropdown.Toggle>
            <Dropdown.Menu className='header-user-drop header-drop'>

              <div className='user-prof'>
                {data?.business_name?.trim() ? (
                  <div>
                    {data.business_name.charAt(0).toUpperCase()}
                  </div>
                ) : (
                  <div className="img-place-bus">
                    <Image
                      src={`${process.env.REACT_APP_BASE_URL}assets/images/my-business.webp`}
                      className="img-fluid"
                      alt="user"
                    />
                  </div>
                )}

                <h5>{data.business_name}</h5>
                <Link to="/business/view-profile">View Profile</Link>
              </div>

              {/* <Link to="/business/edit-business">
                <div>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/profile.webp'} className="img-fluid" alt="profile" />
                  <h6>My Profile</h6>
                </div>
              </Link> */}


              {neighbourchk === 2 ? (
                <Link to="/business/switch-neighbour-profile" >
                  <div>
                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/ian.webp'} className="img-fluid" alt="ian" />
                    <h6>Switch to Neighbor Profile</h6>
                  </div>
                </Link>
              ) : (
                <Link to="#" onClick={switchneighbor}>
                  <div>
                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/ian.webp'} className="img-fluid" alt="ian" />
                    <h6>Switch to Neighbor Profile</h6>
                  </div>
                </Link>
              )}


              <Link to="/business/invite-a-neighbor">
                <div>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/ian.webp'} className="img-fluid" alt="ian" />
                  <h6>Invite a Business</h6>
                </div>
              </Link>
              {/* <Link to="/business/contact-us">
                <div>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cnt.webp'} className="img-fluid" alt="cnt" />
                  <h6>Contact Us</h6>
                </div>
              </Link> */}

              <Link to="#" onClick={logout}>
                <div>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/logout.webp'} className="img-fluid" alt="user" />
                  <h6>Logout</h6>
                </div>
              </Link>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="d-block d-sm-none">
          <Dropdown className="verify-business">
            <Dropdown.Toggle variant="success" id="dropdown-basic" className='header-loc-box '>
              <h6>{address}</h6>
              <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/drop-wh.webp'} className="img-fluid" alt="drop" />
            </Dropdown.Toggle>
            <Dropdown.Menu className='header-loc-drop header-drop'>
              <h6>My Business</h6>
              {businesslist && businesslist.map((val, index) => {
                return (
                  <Link to="#" onClick={() => setBusiness(val.business_id, val.business_name, val.town_name)}>
                    <div>
                      <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/business.webp'} className="img-fluid" alt="business" />
                      <h6>{val.business_name} - {val.town_name}</h6>
                    </div>
                  </Link>
                )
              })}
              <h6>Add Business</h6>
              <Link to="/business/add-new-business" className='ant-box'>
                <div>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/open.webp'} className="img-fluid" alt="open" />
                  <h6>New business</h6>
                </div>
              </Link>
            </Dropdown.Menu>
          </Dropdown>          
        </div>
        <div className='wh-burger-box'>
          <Link onClick={toggleSidebar}>
            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/wh-burger.webp'} className="img-fluid wh-burger" alt="wh-burger" />
          </Link>
          <h3 className='d-none'>LocalBells</h3>
        </div>
      </div>
    </>
  )
}

export default BusinessHeaderAfterLogin;                    